(function() {
	'use strict';
	angular.module('app.setup')
		.service('flexFieldConfigService', flexFieldConfigService);

	flexFieldConfigService.$inject = ['$http', 'URLS'];
	function flexFieldConfigService($http, URLS) {
		var fieldTypeMap = {
			'item': {
				'display': 'Item',
				'tooltip': 'leanFactoryItem',
				'location': 'Item and supply level reports'
			},
			'supply': {
				'display': 'Supply/PO',
				'tooltip': 'leanFactorySupplierPurchaseOrder',
				'location': 'Supply level reports'
			}
		};
		return {
			saveFlexField: saveFlexField,
			fieldTypeMap: fieldTypeMap
		};

		function saveFlexField(id, fieldDefinition, changes, lastModified) {
			var pageUrl = String.format(URLS.flexFields, globalConfig.customer.id);
			if (id > 0) {
				return $http.put(URLS.noFactoryPrefix + pageUrl + '/' + id, changes, { headers: { 'If-Unmodified-Since': lastModified } })
					.then(saveFlexFieldComplete)
					.catch(saveFlexFieldFailed);
			} else {
				var changeObject = Object.assign({}, changes);
				changeObject.fieldDefinition = fieldDefinition;
				return $http.post(URLS.noFactoryPrefix + pageUrl, changeObject)
					.then(saveFlexFieldComplete)
					.catch(saveFlexFieldFailed);
			}

			function saveFlexFieldComplete(response) {
				return response;
			}

			function saveFlexFieldFailed(error) {
				return error;
			}
		}
	}
})();
